// ----------------------------------------------------------------------

export default function Badge(containerId: string) {
  return {
    MuiBadge: {
      defaultProps: {
        container: document.getElementById(containerId),
      },
      styleOverrides: {
        dot: {
          width: 10,
          height: 10,
          borderRadius: '50%',
        },
      },
    },
  };
}
